/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_3_Task_Plant_3_TypesInputs */

const en_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plant 3 Different Types of Plants`)
};

const ar_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ازرع 3 أنواع مختلفة من النباتات`)
};

const de_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pflanzung von 3 verschiedenen Pflanzentypen`)
};

const es_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planta 3 tipos diferentes de plantas`)
};

const fr_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planter 3 types de plantes différents`)
};

const it_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pianta 3 tipi diversi di piante`)
};

const ja_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3種類の植物を植える`)
};

const ko_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`식물 3종 심기`)
};

const pt_br_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plante 3 tipos diferentes de plantas`)
};

const ru_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посадите 3 разных вида растений`)
};

const th_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลูกต้นไม้ที่แตกต่างกัน 3 ชนิด`)
};

const tr_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Farklı Bitki Türü Ek`)
};

const zh_cn_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在森林种植 3 种不同植物`)
};

const zh_tw_phase_3_task_plant_3_types = /** @type {(inputs: Phase_3_Task_Plant_3_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在森林種植 3 種不同植物`)
};

/**
* | output |
* | --- |
* | "Plant 3 Different Types of Plants" |
*
* @param {Phase_3_Task_Plant_3_TypesInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const phase_3_task_plant_3_types = /** @type {((inputs?: Phase_3_Task_Plant_3_TypesInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_3_Task_Plant_3_TypesInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phase_3_task_plant_3_types(inputs)
	if (locale === "ar") return ar_phase_3_task_plant_3_types(inputs)
	if (locale === "de") return de_phase_3_task_plant_3_types(inputs)
	if (locale === "es") return es_phase_3_task_plant_3_types(inputs)
	if (locale === "fr") return fr_phase_3_task_plant_3_types(inputs)
	if (locale === "it") return it_phase_3_task_plant_3_types(inputs)
	if (locale === "ja") return ja_phase_3_task_plant_3_types(inputs)
	if (locale === "ko") return ko_phase_3_task_plant_3_types(inputs)
	if (locale === "pt_br") return pt_br_phase_3_task_plant_3_types(inputs)
	if (locale === "ru") return ru_phase_3_task_plant_3_types(inputs)
	if (locale === "th") return th_phase_3_task_plant_3_types(inputs)
	if (locale === "tr") return tr_phase_3_task_plant_3_types(inputs)
	if (locale === "zh_cn") return zh_cn_phase_3_task_plant_3_types(inputs)
	return zh_tw_phase_3_task_plant_3_types(inputs)
});